import React from "react";
import { Divider, useDisclosure } from "@chakra-ui/react";
import { SideBarContainer } from "./SideBarContainer";
import { SideBarActionSection } from "./SideBarActionSection";
import { SideBarViewSection } from "./SideBarViewSection";
import { SpacesSection } from "./SpacesSection";
import { usePreference } from "../../../hooks/preference/usePreference";
interface SpaceSideBarProps {
  onClickSettings: () => void;
}

export const SpaceSideBar: React.FC<SpaceSideBarProps> = ({ onClickSettings }) => {
  const { updatePreference, preference } = usePreference();

  const { isOpen: isExpanded, onToggle } = useDisclosure({ isOpen: preference.spaceShow ?? true });

  const handleToggleSidebarOpen = () => {
    onToggle();
    updatePreference({ spaceShow: !isExpanded });
  };

  return (
    <SideBarContainer
      isExpanded={isExpanded}
      className="@container/sidebar"
    >
      <SideBarViewSection
        isExpanded={isExpanded}
        onToggleSidebar={handleToggleSidebarOpen}
      />

      <Divider
        bg={"white"}
        opacity={0.08}
      />

      <SpacesSection
        isExpanded={isExpanded}
        onOpenSidebar={handleToggleSidebarOpen}
      />

      <Divider
        bg={"white"}
        opacity={0.08}
      />

      <SideBarActionSection onClickSettings={onClickSettings} />
    </SideBarContainer>
  );
};
